module.exports = __webpack_public_path__ + "media/images/lp/logo_townnavi-fa2e303fe22a2be81fc23524dd4279f2.svg";